"use client";

import { Button } from "../ui/button";

export const AccommodationInfoShortcuts = () => {
  const shortcutList = [
    { link: "#general", title: "مشخصات کلی" },
    { link: "#about", title: "درباره اقامتگاه" },
    { link: "#amenities", title: "امکانات رفاهی" },
    { link: "#location", title: "موقعیت مکانی" },
    { link: "#rules", title: "قوانین و مقررات" },
  ];

  const handleScroll = (
    e: React.MouseEvent<HTMLButtonElement>,
    link: string,
  ) => {
    e.preventDefault();
    const element = document.querySelector(link);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="flex items-center gap-3 overflow-x-auto w-full scroll-smooth snap-x scrollbar-hide">
      {shortcutList?.map((sCut) => (
        <Button
          key={sCut.link}
          variant={"outline"}
          className="text-xs whitespace-nowrap font-normal rounded-[15px] h-10 snap-start"
          onClick={(e) => handleScroll(e, sCut.link)}
        >
          {sCut?.title}
        </Button>
      ))}
    </div>
  );
};
